/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable react/require-default-props */
import React from 'react'
import { Box } from '@material-ui/core'

const TabPanel: React.FC<{
  children?: React.ReactNode
  value: number
  index: number
  id: string
}> = ({ children, value, index, id, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`${id}-tabpanel-${index}`}
    aria-labelledby={`${id}-tab-${index}`}
    {...other}
  >
    {value === index && <Box>{children}</Box>}
  </div>
)

export { TabPanel }
